import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5fabdaeb"
import script from "@/assets/js/web/home.js?vue&type=script&lang=js&external"
export * from "@/assets/js/web/home.js?vue&type=script&lang=js&external"
import style0 from "@/assets/css/web/webAllStyle.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports